module.exports = __webpack_public_path__ + "img/poker-v1-square.81084e9b.jpg";